export default class collectionProcessDialog {
  constructor($scope, $uibModalInstance, httpRequest, logger, items1) {
    console.log(items1)
    $scope.cancel = function cancel() {
      $uibModalInstance.dismiss('cancel')
    }

    $scope.ok = function ok() {
      $uibModalInstance.close()
    }
  }
}
collectionProcessDialog.$inject = [
  '$scope',
  '$uibModalInstance',
  'httpRequest',
  'logger',
  'items1',
]



// WEBPACK FOOTER //
// ./src/app/declaration/vatDeclarationSurcharges/dataCollection/collectionProcessDialog.js